<template>
    <v-container class="pa-2" fluid grid-list-sm >
        <v-card class="shadow-none">
            <v-card-text>
                <xReadContent v-bind:id='20000' v-bind:format='"array"' v-bind:my_elementA="dcontent.data.content" 
                              v-bind:runnable='true' v-bind:task_id ='dcontent.task_id' v-bind:user_course_id = "dcontent.user_course_id"/>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import * as logs from '../../assets/log_process.js'
import xReadContent from '../../components/jprcomponents/etype_xread_content.vue'

export default {
    data() {
        return {
            startTime : null
        }
    },
    props: {
        dcontent: Object,
        taskIndex: Number
    },
    components: {
        xReadContent
    },
    mounted() {
        this.startTime = new Date()
        logs.write_to_log('open', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, 0, this.$store.getters.getAxiosConfig)
        // write passed
        if (!this.dcontent.passed) {
            this.$store.commit('setTransferAnswer',{index: this.taskIndex, rating: 0})            
        }
    },
    beforeDestroy() {
        logs.write_to_log('close', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, Math.floor((new Date() - this.startTime)/1000 + 0.5), this.$store.getters.getAxiosConfig)
    }

}
</script>
